"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _excluded = ["className", "field", "object", "strict"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InputString/index.js";
var defaultProps = {
  object: {},
  type: 'text',
  strict: false
};
function InputString(_ref) {
  var className = _ref.className,
    field = _ref.field,
    object = _ref.object,
    strict = _ref.strict,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _React$useState = _react["default"].useState(object[field] || ''),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  _react["default"].useEffect(function () {
    setValue(object[field] || '');
  }, [object]);
  function onInput(e) {
    var _value = e.target.value;
    var character = _value.charAt(_value.length - 1);
    if (strict && !/^[a-zA-Z]*$/.test(character)) {
      return;
    }
    setValue(_value);
    object[field] = _value;
  }
  return /*#__PURE__*/_react["default"].createElement("input", Object.assign({
    value: value,
    className: (0, _classNames["default"])('form-control', className),
    name: field,
    onInput: onInput
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 9
    }
  }));
}
InputString.defaultProps = defaultProps;
var _default = InputString;
exports["default"] = _default;